/*
 * @Description: 类型
 * @Author: yingbin
 * @Date: 2019-08-23 16:26:26
 * @LastEditTime: 2019-09-03 11:16:49
 * @LastEditors: yingbin
 */
export const USER_INFO = 'USER_INFO'
export const CREATE_INFO = 'CREATE_INFO'
export const IS_AUTH = 'IS_AUTH'